module.exports = __webpack_public_path__ + "static/media/app-bar-account.78515210.svg";